import axios from "axios";
import handleApiError from "../utils/apiErrorHandler";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(handleApiError(error));
  }
);

const parseFetchResponse = async (response) => {
  let data = null;
  try {
    data = await response.clone().json();
  } catch (e) {
    data = null;
  }

  if (!response.ok) {
    throw handleApiError({
      response: { status: response.status, data },
      status: response.status,
      message: response.statusText,
    });
  }

  if (response.status === 204) return null;
  return data;
};

export const apiFetch = async (endpoint, options = {}) => {
  const token = localStorage.getItem("token");
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${process.env.REACT_APP_API_URL}${endpoint}`, {
    ...options,
    headers,
  });

  return parseFetchResponse(response);
};

export { api };
